import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';

import EntryCard from './EntryCard';

const Column = styled.div`
  min-width: 240px;
  max-width: 280px;
  flex-shrink: 0;
  background: #F8FAFC;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  flex-direction: column;
`;

const ColumnHeader = styled.div`
  margin-bottom: 10px;
`;

const LaneLabel = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text.primary};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

// Kolon başı dağılım bandı — hedef/gerçek/⚠ (spec §4). Hedefsiz lane'de
// (TargetPct null — Önerisiz sözde-kolonu HER ZAMAN böyle) yalnız gerçek
// gösterilir.
const DistributionBand = styled.div`
  margin-top: 6px;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  background: ${(p) => (p.$warn ? '#FEF2F2' : '#EFF6FF')};
  color: ${(p) => (p.$warn ? '#E53935' : '#0291EF')};
`;

const EntryList = styled.div`
  flex: 1;
`;

const EmptyHint = styled.div`
  font-size: 12px;
  color: #A0A8B4;
  text-align: center;
  padding: 12px 0;
`;

export default function LaneColumn({
  label, targetPct, actualPct, actualCount, withinTolerance, entries, canMove, onMoveClick,
}) {
  const { t } = useTranslation();
  const showTarget = targetPct !== null && targetPct !== undefined;
  const warn = showTarget && !withinTolerance;

  return (
    <Column data-role="lane-column" data-lane-label={label}>
      <ColumnHeader>
        <LaneLabel>
          <span>{label}</span>
          <span>({actualCount})</span>
        </LaneLabel>
        <DistributionBand data-role="distribution-band" $warn={warn}>
          {warn && <AlertTriangle size={11} />}
          {showTarget
            ? `${t('performance.calibrationSession.grid.targetLabel')}: ${targetPct}% · ${t('performance.calibrationSession.grid.actualLabel')}: ${actualPct}%`
            : `${t('performance.calibrationSession.grid.actualLabel')}: ${actualPct}%`}
        </DistributionBand>
      </ColumnHeader>
      <EntryList>
        {entries.length === 0 && <EmptyHint>{t('performance.calibrationSession.grid.emptyLane')}</EmptyHint>}
        {entries.map((entry) => (
          <EntryCard
            key={entry.calibrationRecordId}
            entry={entry}
            canMove={canMove}
            onMoveClick={onMoveClick}
          />
        ))}
      </EntryList>
    </Column>
  );
}
